<template>
  <el-container>
    <el-header id="header" height="480px">
      <h1>Breast Methylation Age Predictor</h1>
      <el-row type="flex" align="middle" justify="start">
        <el-col id="introduce-container" :span="6" :offset="4">
          <ul>
            <p align="start">
              <big><strong>Introduce</strong></big
              ><br />We developed a breast methylation age predictor (BMAP)
              based on methylation data from human breast tissue. BMAP could
              predict the methylation age based on the methylation data of human
              normal breast tissue. Moreover, BMAP could predict the methylation
              age and breast cancer subtype based on the methylation level of
              breast cancer patients. It has also been found that patients with
              mitosis subtypes have a better response to immunotherapy.
            </p>
          </ul>
        </el-col>
        <el-col :span="5" :offset="3">
          <el-image
            style="width: 100%; height: 350px;"
            :src="demoImgUrl"
            fit="contain"
          ></el-image>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-row type="flex" align="middle" style="padding:16px">
        <el-col>
          <el-radio-group @change="onDataTypeChange" v-model="dataTypeModel">
            <el-radio-button
              v-for="type in dataTypes"
              :key="type"
              :label="type"
              >{{ type }}</el-radio-button
            >
          </el-radio-group>
        </el-col>
        <el-col>
          <el-upload
            action="#"
            ref="upload"
            accept=".tsv"
            :before-upload="beforeUpload"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :disabled="this.fileList.length !== 0"
            :limit="1"
          >
            <!-- <div slot="tip" class="el-upload__tip">
              只能上传tsv文件
            </div> -->
            <el-button
              size="medium"
              type="primary"
              :disabled="this.fileList.length !== 0"
              >Upload Data</el-button
            >
          </el-upload>
        </el-col>
        <el-col>
          <el-button
            size="medium"
            @click="predictData"
            type="warning"
            :loading="isCalculating"
            :disabled="formatData.length <= 0"
            >Predict Methylation Age</el-button
          ></el-col
        >
        <el-col>
          <el-button
            size="medium"
            @click="downloadCSVFile"
            type="success"
            :disabled="tableDatas.length <= 0"
            >Download CSV File</el-button
          ></el-col
        >
      </el-row>
      <div style="margin: 24px 64px 0px 64px;" align="start">
        <strong>Example: </strong
        ><a :href="exampleNormalData" download=NormalData.tsv
          ><strong>NormalData</strong></a
        >&nbsp;
        <a :href="exampleCancerData" download=CancerData.tsv
          ><strong>CancerData</strong></a
        >
      </div>
      <el-row>
        <p id="predict-note" align="start">
          <big><strong>Note</strong></big
          ><br />The row and column of the uploaded file are the sample name and
          the probe, respectively. The upload file should contain cg02497785,
          cg05632420, cg06144905, cg06458239, cg07477282, cg08169949,
          cg10060631, cg13158894, cg14055004, cg14676592, cg14961391,
          cg15571405, cg15909319, cg16867657, cg17940694, cg18879828,
          cg19925755, cg23606718, cg25894658, cg26304119 and cg26830108. If you
          want to predict the subtype of breast cancer, the data you upload
          should contain information about the age of the sample.
        </p>
      </el-row>
      <el-row style="margin: 36px 48px 0 48px">
        <el-table
          stripe
          :data="
            tableDatas.slice(
              (currentPage - 1) * pageSize,
              currentPage * pageSize
            )
          "
          style="width: 100%"
        >
          <el-table-column
            sortable
            prop="sampleLabel"
            label="Sample"
            width="180"
          >
          </el-table-column>
          <el-table-column
            v-if="dataTypeModel === 'Cancer'"
            sortable
            prop="sampleAge"
            label="Age"
            width="180"
          >
          </el-table-column>
          <el-table-column sortable prop="sampleDNAm" label="DNAm">
          </el-table-column>
          <el-table-column
            v-if="dataTypeModel === 'Cancer'"
            sortable
            prop="sampleDiff"
            label="Methylation age accelerate"
          >
          </el-table-column>
          <el-table-column
            prop="sampleGroup"
            v-if="dataTypeModel === 'Cancer'"
            label="Group"
          >
          </el-table-column>
          <div slot="empty">
            No Data
          </div>
        </el-table>
      </el-row>
      <el-row style="margin: 18px 0 0 0">
        <el-pagination
          background
          hide-on-single-page
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="tableDatas.length"
        >
        </el-pagination>
      </el-row>
    </el-main>
    <el-footer>
      <el-divider></el-divider>
      <el-row type="flex" justify="space-around">
        <el-col>
          <i class="el-icon-message" style="color:#f6546a"></i>
          <p>Li Xia</p>
          <a href="mailto:lixia@hrbmu.edu.cn">lixia@hrbmu.edu.cn</a></el-col
        >
        <el-col>
          <i class="el-icon-message" style="color:#794044"></i>
          <p>Ning ShangWei</p>
          <a href="mailto:ningsw@ems.hrbmu.edu.cn"
            >ningsw@ems.hrbmu.edu.cn</a
          ></el-col
        >
        <el-col>
          <i class="el-icon-message" style="color:#088da5"></i>
          <p>Shang Shipeng</p>
          <a href="bio_shangsp@163.comn">bio_shangsp@163.com</a></el-col
        >
      </el-row>
      <el-row
        ><p>
          <strong
            >2020, CopyRight © College of Bioinformatics Science and Technology,
            Harbin Medical University, China.</strong
          >
        </p></el-row
      >
    </el-footer>
  </el-container>
</template>

<script>
import NP from "number-precision";
export default {
  name: "HomePage",
  props: {},
  data() {
    return {
      demoImgUrl: require("@/assets/images/breast_cancer_subtype.jpg"),
      exampleNormalData: require("@/assets/data/NormalData.tsv"),
      exampleCancerData: require("@/assets/data/CancerData.tsv"),
      fileList: [],
      dataStr: null,
      formatData: [],
      tableDatas: [],
      isCalculating: false,
      pageSize: 10,
      currentPage: 1,
      currentFileName: "",
      dataTypeModel: "Normal",
      dataTypes: ["Normal", "Cancer"],
      fixedFactorWeights: {
        cg02497785: 3.489592186,
        cg05632420: -7.83182754,
        cg06144905: 23.5599478,
        cg06458239: 15.0839553,
        cg07477282: 27.57613069,
        cg08169949: 9.731079514,
        cg10060631: 40.726325,
        cg13158894: 5.610943047,
        cg14055004: -11.56017034,
        cg14676592: 31.30117003,
        cg14961391: -2.259247052,
        cg15571405: -2.782152708,
        cg15909319: 20.44228166,
        cg16867657: 6.598275275,
        cg17940694: 13.06777821,
        cg18879828: -4.585643536,
        cg19925755: 67.23175737,
        cg23606718: 30.67464654,
        cg25894658: 12.87168649,
        cg26304119: 1.564529685,
        cg26830108: 39.66352047,
      },
      fixedDeviation: -86.7286162833475,
      fixedDevelopmentThreshold: 10.6,
      fixedMitosisThreshold: -10.6,
    };
  },

  beforeCreate() {},
  methods: {
    handleExceed(files, fileList) {
      this.commonAlert(`Only 1 File`);
    },
    beforeUpload(file) {
      this.resetData();
      this.fileList = [file];
      this.currentFileName = file.name.substr(0, file.name.lastIndexOf("."));
      // 读取数据
      let str = this.readFileAsText(file);
      return false;
    },
    onDataTypeChange(val) {
      this.resetData();
    },
    readFileAsText(f) {
      let rd = new FileReader();
      this.formatData = [];
      rd.readAsText(f);
      rd.onload = (e) => {
        this.dataStr = e.target.result;
        this.parseDatas(this.dataStr);
      };
    },
    parseDatas(str) {
      // 过滤换行符
      str = str.replace(new RegExp("\\r", "g"), "");
      let rows = str.split("\n");
      rows.forEach((item, index) => {
        let labels;
        if (0 === index) {
          // 解析标题
          labels = item.split("\t");
          this.formatData = new Array(labels.length - 1);
          labels.forEach((label, labelIndex) => {
            if (labelIndex > 0) {
              this.formatData[labelIndex - 1] = { label: label };
            }
          });
        } else if (item.startsWith("age")) {
          // 解析年龄数据
          let currentRowData = item.split("\t");
          currentRowData.forEach((data, dataIndex) => {
            if (dataIndex > 0) {
              this.formatData[dataIndex - 1].age = parseInt(data);
            }
          });
        } else {
          // 将数据存储到formatData对象
          let currentRowData = item.split("\t");
          currentRowData.forEach((data, dataIndex) => {
            if (dataIndex > 0) {
              this.formatData[dataIndex - 1][currentRowData[0]] = parseFloat(
                data
              );
            }
          });
        }
      });
      if (!this.validateData(this.formatData, this.dataTypeModel)) {
        this.resetData();
      }
    },
    predictData() {
      this.isCalculating = true;
      this.fileList = [];
      this.tableDatas = [];
      this.calculateFactorScore(this.formatData);
      const sortDatas = this.formatData.sort((a, b) => {
        if (this.dataTypeModel === "Cancer") {
          return b.diff - a.diff;
        } else {
          return b.DNAm - a.DNAm;
        }
      });
      sortDatas.forEach((data) => {
        const tableData = {};
        tableData.sampleLabel = data.label;
        tableData.sampleAge = data.age;
        tableData.sampleDNAm = data.DNAm ? data.DNAm.toFixed(2) : 0;
        tableData.sampleDiff = data.diff ? data.diff.toFixed(2) : 0;
        tableData.sampleGroup = data.group;
        this.tableDatas.push(tableData);
      });
      this.isCalculating = false;
    },
    calculateFactorScore(datas) {
      datas.forEach((data, dataIndex) => {
        let DNAm = 0;
        for (let weightKey in this.fixedFactorWeights) {
          DNAm = DNAm + this.fixedFactorWeights[weightKey] * data[weightKey];
        }
        data.DNAm = DNAm + this.fixedDeviation;
        if (!isNaN(data.age)) {
          data.diff = data.DNAm - (isNaN(data.age) ? 0 : data.age);
          if (data.diff > this.fixedDevelopmentThreshold) {
            data.group = "Development";
          } else if (data.diff < this.fixedMitosisThreshold) {
            data.group = "Mitosis";
          } else {
            data.group = "Homeostasis";
          }
        }
      });
    },
    validateData(data, dataType) {
      let result = true;
      if (!(data instanceof Array) || !(data.length > 0)) {
        result = false;
        this.commonAlert("Illegal data!");
      }
      if (
        result &&
        dataType === "Cancer" &&
        data[0] instanceof Object &&
        !Object.prototype.hasOwnProperty.call(data[0], "age")
      ) {
        result = false;
        this.commonAlert("Cannot find Age!");
      }
      if (result) {
        let alertContent = "";
        for (let weightKey in this.fixedFactorWeights) {
          if (!Object.prototype.hasOwnProperty.call(data[0], weightKey)) {
            result = false;
            alertContent = alertContent + weightKey + "\n";
          }
        }
        if (!result) {
          this.commonAlert("MIssing factor" + alertContent);
        }
      }
      return result;
    },
    getSummaries(param) {
      const { columns, data } = param;
      if (data === null) {
        return [];
      }
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        if (column.label === "Age") {
          sums[index] = "N/A";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    resetData() {
      this.isCalculating = false;
      this.fileList = [];
      this.dataStr = null;
      this.formatData = [];
      this.tableDatas = [];
    },
    downloadCSVFile() {
      //创建一个blob对象,file的一种
      let cacheStr = "Sample";
      if (this.dataTypeModel === "Cancer") {
        cacheStr += ",age";
      }
      cacheStr += ",DNAm";
      if (this.dataTypeModel === "Cancer") {
        cacheStr += ",Methylation age accelerate";
        cacheStr += ",Group";
      }
      cacheStr += "\r\n";
      console.log(this.tableDatas);
      let totalDNAm = 0,
        totalDiff = 0;
      this.tableDatas.forEach((tableData) => {
        cacheStr += tableData.sampleLabel;
        if (this.dataTypeModel === "Cancer") {
          cacheStr = cacheStr + "," + tableData.sampleAge;
        }
        totalDNAm += parseFloat(tableData.sampleDNAm);
        cacheStr = cacheStr + "," + tableData.sampleDNAm;
        if (this.dataTypeModel === "Cancer") {
          totalDiff += parseFloat(tableData.sampleDiff);
          cacheStr = cacheStr + "," + tableData.sampleDiff;
          cacheStr = cacheStr + "," + tableData.sampleGroup;
        }
        cacheStr += "\r\n";
      });
      cacheStr += "Total";
      if (this.dataTypeModel === "Cancer") {
        cacheStr = cacheStr + ",N/A";
      }
      cacheStr = cacheStr + "," + totalDNAm.toFixed(2);
      if (this.dataTypeModel === "Cancer") {
        cacheStr = cacheStr + "," + totalDiff.toFixed(2);
        cacheStr = cacheStr + "," + "N/A";
      }
      var uri =
        "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(cacheStr);
      var downloadLink = document.createElement("a");
      downloadLink.href = uri;
      downloadLink.download =
        this.currentFileName + "PredictResult.csv" || "temp.csv";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    logEverySocre(datas, dataType) {
      datas.forEach((data) => {
        if (dataType === "Cancer") {
          console.log(data.label + "===" + data.diff);
        } else {
          console.log(data.label + "===" + data.DNAm);
        }
      });
    },
    commonAlert(msg) {
      this.$notify.error({
        title: "Alert",
        message: msg,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#header {
  background: linear-gradient(45deg, #e86e73, #46426f);
}
#header > h1 {
  color: #ffffff;
  font-size: 40px;
  font-weight: 600;
}
#header p {
  color: white;
}
#predict-note {
  margin: 24px 64px 0px 64px;
  font-size: 18px;
  color: #6c6b66;
}
</style>
